document.addEventListener("DOMContentLoaded", function () {

    Array.prototype.slice.call(document.querySelectorAll('.product-highlights-spot')).forEach(function (accordion) {
        var checkboxButtons = Array.prototype.slice.call(accordion.querySelectorAll('.phs__checkbox'));
        var numberTrigger = Array.prototype.slice.call(accordion.querySelectorAll('.phs__number-trigger'));

        checkboxButtons.forEach(function (checkboxElement) {
            checkboxElement.addEventListener('change', function (event) {
                var numberItem = accordion.querySelector('.phs__number-trigger[for="' + event.target.id + '"]');
                event.target.checked ? numberItem.classList.add('is-expanded') : numberItem.classList.remove('is-expanded');
            });
        });

        // it is for scroll to open accordion, when it isn't in the viewport
        numberTrigger.forEach(function (numberElement) {
            numberElement.addEventListener('click', function (event) {
                // Only jump to the section when on mobile
                if (!event.target.classList.contains('is-expanded') && window.innerWidth < 768) {
                    var forId = event.target.getAttribute('for');
                    var collapsibleContentOffset = accordion.querySelector('.phs__text-trigger[for="' + forId + '"]').getBoundingClientRect().top + document.documentElement.scrollTop;
                    window.scrollTo(0, collapsibleContentOffset);
                }
            });
        });
    });

});